import { RouteConfig } from 'vue-router';
import StaticPages from '../views/StaticPages/Index.vue';
import campaignLandingPage from '../views/campaignLandingPage.vue';
import mobileCampaignLandingPage from '../views/mobileCampaignLandingPage.vue';
import mobileStaticPage from '../views/mobileStaticPage.vue';
import risingStars from '../views/risingStars.vue';

const routes: Array<RouteConfig> = [
  {
    path: '/cargoStatus',
    name: 'CargoStatus',
    component: () => import('../views/CargoStatus.vue'),
  },
  {
    path: '/alternativeDeliveryStaticpage',
    name: 'AlternativeDelivery',
    component: () => import('../views/AlternativeDelivery.vue'),
  },
  {
    path: '/digitalDeliveryStaticpage',
    name: 'DigitalDelivery',
    component: () => import('../views/DigitalDelivery.vue'),
  },
  {
    path: '/static-pages',
    component: StaticPages,
    children: [
      {
        path: 'customer-invoice',
        name: 'CustomerInvoice',
        component: () => import('../views/StaticPages/CustomerInvoice/Index.vue'),
      },
      {
        path: 'vito',
        name: 'Vito',
        component: () => import('../views/vito.vue'),
      },
    ],
  },
  {
    path: '/kasim-kampanyalari',
    name: 'campaignLandingPage',
    component: campaignLandingPage,
    beforeEnter: (to, from, next) => {
      const { saleType } = window.user;
      if (saleType === 'MEAL' || saleType === 'MARKET') {
        window.location.href = '/';
        return;
      }
      // eslint-disable-next-line consistent-return
      return next();
    },
  },
  {
    path: '/mobile-kasim-kampanyalari',
    name: 'mobileCampaignLandingPage',
    component: mobileCampaignLandingPage,
  },
  {
    path: '/yukselen-yildizlar-programi',
    name: 'campaignLandingPage',
    component: risingStars,
  },
  {
    path: '/mobile-static-page',
    name: 'mobileStaticPage',
    component: mobileStaticPage,
  },
];

export default routes;
